import { render } from "./verification_step.vue?vue&type=template&id=6aa0ba5c"
import script from "./verification_step.vue?vue&type=script&lang=js"
export * from "./verification_step.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/submission_form/verification_step.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6aa0ba5c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6aa0ba5c', __exports__)) {
    api.reload('6aa0ba5c', __exports__)
  }
  
  module.hot.accept("./verification_step.vue?vue&type=template&id=6aa0ba5c", () => {
    api.rerender('6aa0ba5c', render)
  })

}


export default __exports__